/**
 * Service class in charge of mapping the state to props.
 */
import livestreamActions from '../../actions/LivestreamActions';
import liveSessionService from './LiveSessionService';
import sessionReader from '../../store/readHelpers/SessionReader';

/**
 * The following functions has been moved to confirmHardwareSettingsSelector:
 * - isConfirmHardwareSettingsButtonDisabled
 * - showWarningMissingAudioDevice
 * - showWarningMissingWebcamDevice
 */
const livestreamService = {
    isCompleted(state) {
        // TEII-2810: Only works when onlyWatchAndCallEnabled is available.
        return (
            (!!state.liveSessionId || !sessionReader.isWatchAndCallEnabled())
            && liveSessionService.areRequiredDevicesBeingRecorded(state)
        );
    },

    hasFailed(state) {
        return liveSessionService.isHardwareAccessRejected(state);
    },

    resolveComponentClassName(state) {
        if (liveSessionService.isHardwareAccessRejected(state)) {
            return 'componentFailed';
        }
        return 'componentDefault';
    },

    resolveStatusTextClassName(state) {
        if (this.isCompleted(state)) {
            return 'completed';
        }
        return 'incomplete';
    },

    resolveStatusCaption(state) {
        if (this.isCompleted(state)) {
            return 'hardwareAccessCheck.liveProctoringHasStarted';
        }
        return 'childTest.notCompleted';
    },

    resolveStatusDescriptionCaption(state) {
        if (this.isCompleted(state)) {
            return 'hardwareAccessCheck.completed';
        } else if (liveSessionService.isHardwareAccessRejected(state)) {
            return 'hardwareAccessCheck.accessRejected';
        }
        return null;
    },

    resolveCallingProctor(state) {
        const proctors = this.resolveCallingProctors(state);
        return proctors.length ? proctors[0] : undefined;
    },

    /**
     * Resolves all the proctors (proctorId list of strings) that are currently in a call with the candidate.
     * This list is sorted by the time at which the proctor entered the Call mode.
     * @param state
     * @returns {Array.<String>}
     */
    resolveCallingProctors(state) {
        return Object.keys(state.registeredCalls).filter((proctorId) => {
            const proctorCall = state.registeredCalls[proctorId];
            return proctorCall && proctorCall.proctoringMode === livestreamActions.proctoringMode.CALL;
        }).sort((a, b) => {
            const call1 = state.registeredCalls[a];
            const call2 = state.registeredCalls[b];
            if (call1.proctoringModeSetTime < call2.proctoringModeSetTime) {
                return -1;
            }
            if (call1.proctoringModeSetTime > call2.proctoringModeSetTime) {
                return 1;
            }
            return 0;
        });
    },

    resolveLiveSessionTimestamp(state, messagerId) {
        const existingCall = state.registeredCalls[messagerId];
        return existingCall ? existingCall.liveSessionTimestamp : undefined;
    },

    resolveConnectionStatus(state, messagerId) {
        const existingCall = state.registeredCalls[messagerId];
        return existingCall.connectionStatus;
    },
};

export default livestreamService;
